<template>
    <span>
        <a href="javascript:void(0);" @click="showModal = true">
            <slot>Link</slot>
        </a>
        <modal-dialog v-if="showModal" @close="onClose" @onSave="onSave">
            <div slot="body" class="text-left">
                <div v-if="button">

                    <div class="row" :class="{'has-error': errors.has('buttonName')}">
                        <div class="col-md-3"><label for="name">Button Name</label></div>
                        <div class="col-md-6">
                            <input type="text" class="form-control" v-model="button.title" maxlength="20" name="buttonName" data-vv-as="Button Name" v-validate="'required'">
                            <p class="text-error" v-show="errors.has('buttonName')">{{ errors.first('buttonName') }}</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12" style="overflow-x:auto;margin-top: 15px;margin-bottom: 15px;">
                            <ul style="list-style-type: none;margin: 0; padding: 0">
                                <li style="display: inline-block; margin-bottom: 5px;">
                                    <a href="javascript:void(0);" class="btn" @click="changeType('web_url');button.url = ''" :class="{'btn-primary' : currentType == 'web_url', 'btn-default' : currentType != 'web_url'}"><span class="glyphicon glyphicon-link"></span>  Link</a>
                                </li>
                                
                                <li style="display: inline-block; margin-bottom: 5px;">
                                    <a href="javascript:void(0);" class="btn" @click="changeType('postback');button.payload = button.title" :class="{'btn-primary' : currentType == 'postback', 'btn-default' : currentType != 'postback'}"><span class="glyphicon glyphicon-font"></span>  Text</a>
                                </li>

                                <li style="display: inline-block; margin-bottom: 5px;">
                                    <a href="javascript:void(0);" class="btn" @click="changeType('phone_number');button.payload = ''" :class="{'btn-primary' : currentType == 'phone_number', 'btn-default' : currentType != 'phone_number'}"><i class="fas fa-phone"></i>  Call</a>
                                </li>
                                
                                <template v-if="selectedBot.theme == 'ecommercebasic'">

                                <li style="display: inline-block; margin-bottom: 5px;">
                                    <a href="javascript:void(0);" class="btn" @click="changeType('web_url');button.url = '{shopurl}'" :class="{'btn-primary' : currentType == 'shopurl', 'btn-default' : currentType != 'shopurl'}"><span class="glyphicon glyphicon-home"></span>  Shop Link</a>
                                </li>


                                <li style="display: inline-block; margin-bottom: 5px;" v-if="setting.allowtransfer">
                                    <a href="javascript:void(0);" class="btn" @click="changeType('web_url');button.url = '{transferurl}'" :class="{'btn-primary' : currentType == 'transferurl', 'btn-default' : currentType != 'transferurl' , 'unavailable' : setting.allowtransfer.contentvalue == false}"><span class="glyphicon glyphicon-transfer"></span>  Transfer Link</a>
                                </li>

                                <li style="display: inline-block; margin-bottom: 5px;" v-if="setting.allowcreditcard">
                                    <a href="javascript:void(0);" class="btn" @click="changeType('web_url');button.url = '{creditcardurl}'" :class="{'btn-primary' : currentType == 'creditcardurl', 'btn-default' : currentType != 'creditcardurl', 'unavailable' : setting.allowcreditcard.contentvalue == false || selectedBot.paypal_merchantid == null}"><span class="glyphicon glyphicon-credit-card"></span>  Credit Card Link</a>
                                </li>

                                </template>

                                <!-- <li style="display: inline-block; margin-bottom: 5px;">
                                    <a href="javascript:void(0);" class="btn" @click="changeType('web_url');button.url = '{viewsummary}'" :class="{'btn-primary' : currentType == 'viewsummary', 'btn-default' : currentType != 'viewsummary'}"><span class="glyphicon glyphicon-shopping-cart"></span>  Cart Summary</a>
                                </li> -->

                                
                            </ul>
                        </div>
                    </div>

                    <div>

                        <div v-if="currentType == 'shopurl'">
                                Redirect customer to shop
                        </div>
                        <div v-if="currentType == 'transferurl'">
                            Redirect customer to transfer page
                        </div>
                        <div v-if="currentType == 'creditcardurl'">
                            Redirect customer to credit card payment page
                            
                            <div class="alert alert-warning" role="alert" style="margin-top: 15px;" v-if="setting.allowcreditcard && (setting.allowcreditcard.contentvalue == false || selectedBot.paypal_merchantid == null)">
                                <strong>Warning</strong> You haven't registered credit card payment. Go to Setting page to Link PayPal Account for chatbot.
                            </div>
                        </div>
                        <div v-if="currentType == 'web_url'">
                            <div class="row" :class="{'has-error': errors.has('buttonLink')}">
                                <div class="col-md-3"><label for="link">Link</label></div>
                                <div class="col-md-6">
                                    <textarea name="buttonLink" key="button-link" :data-vv-name="'buttonLink'" rows="10" class="form-control" style="width: 100%; resize: none" v-model="button.url" data-vv-as="Link" v-validate="(currentType == 'web_url' ? 'required|' : '') + 'isUrl'" placeholder="www.website.com"></textarea>
                                    <p class="text-error" v-show="errors.has('buttonLink')">{{ errors.first('buttonLink') }}</p>
                                </div>
                            </div>
                        </div>

                        <div v-else-if="currentType == 'phone_number'">
                            <div class="row" :class="{'has-error': errors.has('buttonPhoneNumber')}">
                                <div class="col-md-3"><label for="phone_number">Phone Number</label></div>
                                <div class="col-md-6">
                                    <textarea name="buttonPhoneNumber" key="button-phone-number" :data-vv-name="'buttonPhoneNumber'" rows="10" class="form-control" style="width: 100%; resize: none" v-model="button.payload" data-vv-as="Phone Number" v-validate="(currentType == 'phone_number' ? 'required|' : '') + 'isPhone'" placeholder="+66812345678"></textarea>
                                    <p class="text-error" v-show="errors.has('buttonPhoneNumber')">{{ errors.first('buttonPhoneNumber') }}</p>
                                </div>
                            </div>
                        </div>

                        <div v-if="currentType == 'postback'">
                            <div style="border-top: 1px solid #eee;margin-bottom: 15px;"></div>
                            <div class="text-center">
                                <a href="javascript:void(0);" class="btn btn-primary transparent btn-sm" @click="showAdvanced = !showAdvanced">Show Advanced
                                    <i class="fa" :class="{'fa-angle-down' : showAdvanced , 'fa-angle-up' : !showAdvanced}"></i>
                                </a>
                            </div>
                            <div class="row" :class="{'has-error': errors.has('buttonPayload')}" v-show="showAdvanced" style="margin-top: 15px;">
                                <div class="col-md-3"><label for="link">Action</label></div>
                                <div class="col-md-6">
                                    <input name="buttonPayload" key="button-payload" :data-vv-name="'buttonPayload'" rows="5" class="form-control" style="width: 100%; resize: none" v-model="button.payload" data-vv-as="Text" v-validate="currentType == 'postback' ? 'required' : ''" placeholder="Type action"/>
                                    <p class="text-error" v-show="errors.has('buttonPayload')">{{ errors.first('buttonPayload') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal-dialog>
    </span>
</template>

<script>

import ModalDialog from '@/components/elements/ModalDialog'
import { mapGetters } from 'vuex'
    export default {
        props: ['value'],
        
        data: function(){
            return {
                showModal: false,
                button: {
                    title: '',
                    type: '',
                },
                text: '',
                showAdvanced: false
            }
        },
        computed: {
            ...mapGetters({
                selectedBot: 'selectedBot',
                setting: 'setting'
            }),
            currentType: function(){
                if (this.button.type == 'web_url') {
                    if( this.button.url == '{shopurl}') {
                        return 'shopurl'
                    }
                    else if( this.button.url == '{transferurl}') {
                        return 'transferurl'
                    }
                    else if( this.button.url == '{creditcardurl}') {
                        return 'creditcardurl'
                    }
                    else if( this.button.url == '{viewsummary}'){
                        return 'viewsummary'
                    }
                    else {
                        return 'web_url'
                    }
                } else if(this.button.type == 'postback'){
                    return 'postback'
                } else if(this.button.type == 'phone_number'){
                    return 'phone_number'
                } else {
                    return ''
                }
            }
        },
        components: {
            ModalDialog
        },
        created: function(){
            this.button = Object.assign({}, this.value)
            this.cache_button = Object.assign({}, this.value)

            if (this.currentType == 'postback') {
                if(this.button.title != this.button.payload){
                    this.showAdvanced = true
                }
            }

        },
        methods: {
            onSave:function() {
                var vm = this
                vm.$validator.validate().then(result => {
					if (!result) {
                        // do stuff if not valid.
                        vm.goToErrorInput()
						return false
                    }
                    vm.cache_button = Object.assign({}, vm.button)
                    vm.showModal = false
                    vm.$emit('onSave',this.button)
                })
            },
            onClose: function () {
                this.button = Object.assign({}, this.cache_button)
                this.showModal = false
            },
            changeType: function(type){
                this.button.type = type
                this.errors.clear();
            }
        },
        watch: {
            value: function(){
                this.button = Object.assign({}, this.value)
                this.cache_button = Object.assign({}, this.value)
            },
            'button.title': function(newVal, oldVal){
                if(newVal != oldVal && this.currentType == 'postback'){
                    this.button.payload = newVal
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/chatbot/AddGenericButton.vue